import React from 'react';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

/*
  Call this with something like
  <KDatePicker
    label={someLabel}
    value={someValue}
    onChange={(newDate) => {....}}
    onNull={() => {...}} (optional)
  />
*/

const KDatePicker = ({ label, value, onChange, onNull }) => {
  const handleDateChange = (newDate) => {
    if (newDate) {
      value = newDate;
      if (!newDate.invalid) {
        onChange(newDate);
      }
    } else {
      if (onNull) {
        onNull();
      }
    }
  };

  return (
    <DatePicker
      label={label}
      inputFormat="MM/dd/yyyy"
      value={value}
      onChange={handleDateChange}
      renderInput={(params) => <TextField {...params} variant="standard" />}
    />
  );
};

export default KDatePicker;
